import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Grid,
  Typography,
} from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import * as React from "react";

interface Props {
  children: any;
  title: string;
  onEnabledChange: (enabled: boolean) => void;
  enabled: boolean;
}

class FilterContainer extends React.Component<Props & StyledComponentProps> {
  public state = {
    expanded: this.props.enabled,
  };
  private handleAccordionChange = (event: unknown, expanded: boolean) => {
    this.setState({ expanded });
  };

  public componentDidUpdate = (prevProps: Props) => {
    if (prevProps.enabled !== this.props.enabled) {
      this.setState({ expanded: this.props.enabled });
    }
  };

  private isFilterGroupDisabled = (filterGroupEnabled: boolean) =>
    !filterGroupEnabled;

  public render() {
    const { classes } = this.props;
    return (
      <Accordion
        className={classes && classes.accordion}
        expanded={this.state.expanded}
        onChange={this.handleAccordionChange}
      >
        <AccordionSummary
          className={classes && classes.accordionSummary}
          expandIcon={<ExpandMoreIcon />}
        >
          <Grid container spacing={1} alignItems="center" justify="flex-start">
            <Grid item>
              <Checkbox
                className={classes && classes.checkbox}
                checked={this.props.enabled}
                onChange={(event) => {
                  this.props.onEnabledChange(event.target.checked);
                  this.setState({ expanded: event.target.checked });
                }}
                onClick={(event) => event.stopPropagation()}
              />
            </Grid>
            <Grid item>
              <Typography variant="subtitle1">{this.props.title}</Typography>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <div className={classes && classes.childrenWrapper}>
            {this.props.children(
              this.isFilterGroupDisabled(this.props.enabled)
            )}
          </div>
        </AccordionDetails>
      </Accordion>
    );
  }
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  checkbox: {
    transform: "scale(1.2)",
  },
  childrenWrapper: {
    width: "100%",
  },
  accordion: {
    boxShadow: "none !important",
    border: `1px solid ${grey[400]}`,
    borderRadius: "4px",
    "& .MuiAccordionSummary-root": {
      paddingLeft: theme.spacing(1),
    },
  },
  accordionSummary: {
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
  },
});
export default withStyles(styles)(FilterContainer);



// WEBPACK FOOTER //
// ./src/components/Filters/FilterContainer.tsx